import { render, staticRenderFns } from "./DensitiesManagerForm.vue?vue&type=template&id=406dfdc8&"
import script from "./DensitiesManagerForm.vue?vue&type=script&lang=ts&"
export * from "./DensitiesManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports